export default __webpack_public_path__ + "static/media/MEBSZ.f51f241f.png";